module.exports = __webpack_public_path__ + "img/icon-ok-green.a0f97c98.png";